import { useEffect, useState } from 'react';

import {
  useClientAccountDocumentsLazy,
  useLegalClientAccountDocumentsLazy,
} from 'api/requests';
import { lodash } from 'helpers';
import {
  isLegalClientRepresentative,
  isPersonClient,
  isPersonClientRepresentative,
} from 'helpers/client';
import { useUser } from 'libs/providers';

export const useAccountDocuments = () => {
  const { client } = useUser();

  const [loading, setLoading] = useState(true);

  const {
    documents: clientDocuments,
    getAccountDocuments: getClientDocuments,
    loading: clientDocumentsLoading,
  } = useClientAccountDocumentsLazy();

  const {
    documents: legalClientDocuments,
    getAccountDocuments: getLegalClientDocuments,
    loading: legalClientDocumentsLoading,
  } = useLegalClientAccountDocumentsLazy();

  const documents = lodash.compact([
    ...clientDocuments,
    ...legalClientDocuments,
  ]);

  useEffect(() => {
    if (!client?.type) return;

    if (isPersonClient(client.type)) {
      getClientDocuments(client.id).finally(() => setLoading(false));
    } else if (isPersonClientRepresentative(client.type)) {
      getClientDocuments(client.ownerId!).finally(() => setLoading(false));
    } else if (isLegalClientRepresentative(client.type)) {
      getLegalClientDocuments(client.ownerId!).finally(() => setLoading(false));
    }
  }, [
    client?.type,
    client?.id,
    getClientDocuments,
    getLegalClientDocuments,
    client?.ownerId,
  ]);

  return {
    documents,
    loading: loading || clientDocumentsLoading || legalClientDocumentsLoading,
  };
};
